import store from '@/store';
import { calcDate } from "@/util/date.js";
export default {
    height: "auto",
    calcHeight: 30,
    tip: false,
    searchShow: true,
    searchSpan: 6,
    searchMenuSpan: 6,
    border: true,
    index: true,
    viewBtn: false,
    editBtn: false,
    delBtn: false,
    addBtn: false,
    selection: false,
    dialogClickModal: false,
    searchLabelWidth: 100,
    column: [{
            label: "主键id",
            prop: "id",
            type: "input",
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            hide: true,
        },
        {
            label: "进件编号",
            prop: "businessCode",
            type: "input",
            minWidth:140,
            search: true,
            searchOrder: 995,
        },
        {
            label: "所属代理商",
            prop: "businessDeptName",
            minWidth:140,
            type: "input",
        },
        {
            label: "产品类型",
            prop: "rentType",
            type: "select",
            minWidth:100,
            dicData: store.getters.porductTypes
        },
        {
            label: "产品类型",
            prop: "rentTypeList",
            type: "select",
            hide: true,
            search: true,
            searchOrder: 999,
            searchMultiple: true,
            dicData: store.getters.porductTypes
        },
        {
            label: "租赁人",
            prop: "name",
            type: "input",
            minWidth:100,
            search: "true",
            searchOrder: 998,
        },
        {
            label: "手机号",
            prop: "phoneNumber",
            minWidth:100,
            type: "input",
        },
        {
            label: "租赁金额",
            prop: "lendingAmount",
            minWidth:100,
            type: "input",
        },
        {
            label: "每月租金",
            prop: "lendingAmountPer",
            minWidth:100,
            type: "input"
        },
        {
            label: "车牌号",
            prop: "carFirstNumber",
            minWidth:100,
            type: "input",
            search: true,
            searchOrder: 997,
        },
        {
          label: '逾期天数',
          prop: 'delayDays',
          minWidth:100,
          type: 'input',
          formatter: (val, value, label) => {
            return value ? value + '天' : value;
          },
        },
        {
          label: '滞留时间',
          prop: 'currentTime',
          minWidth:140,
          type: 'input',
          formatter: (val, value, label) => {
            if (!value) return '';
            const date = calcDate(new Date(value).getTime(), new Date().getTime());
            return `${date.days}天${date.hours}小时${date.minutes}分`;
          },
        },
        // {
        //   label: '耗时',
        //   prop: 'timeConsuming',
        //   hide: true,
        // },
        {
          label: '谈判结果',
          prop: 'returnCat',
          type: 'select',
          hide: true,
          search: false,
          searchOrder: 996,
          dicData: [
            {
              label: '客户违约结清',
              value: 1,
            },
            {
              label: '继续还款',
              value: 2,
            },
          ],
        },
        // {
        //     label: "上次谈判时间",
        //     prop: "lastNegotiationTime",
        //     type: "input",
        // },
        {
            label: "所属代理商",
            prop: "businessDeptIdList",
            type: "select",
            filterable: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            search: true,
            searchMultiple: true,
            searchClearable: true,
            defaultExpandAll: true,
            searchOrder: 1000,
            hide: true,
            dicData: [],
            props: {
                label: "title",
                value: "id",
            },
        },
        // {
        //   label: "类型",
        //   prop: "actionSourceType",
        //   type: "select",
        //   hide: true,
        //   showColumn: false,
        //   search: true,
        //   dicData: [
        //     {
        //       label: "逾期未还",
        //       value: 1
        //     },
        //     {
        //       label: "合同违约",
        //       value: 2
        //     },
        //     {
        //       label: "其他",
        //       value: 99
        //     }
        //   ]
        // },
        // {
        //   label: "类型",
        //   prop: "actionSourceTypeList",
        //   type: "select",
        //   dataType: "number",
        //   dicData: [
        //     {
        //       label: "逾期未还",
        //       value: 1
        //     },
        //     {
        //       label: "合同违约",
        //       value: 2
        //     },
        //     {
        //       label: "其他",
        //       value: 99
        //     }
        //   ],
        //   value: 0
        // },
        {
            label: "还租日期",
            prop: "currentLendingDate",
            type: "date",
            hide: true,
            searchRange: true,
            searchType: "daterange",
            valueFormat: "yyyy-MM-dd",
        },
        {
            label: "车辆状态",
            prop: "vehicleState",
            hide: true,
            type: "select",
            dataType: "number",
            dicData: [{
                    label: "待售",
                    value: 0
                },
                {
                    label: "已售",
                    value: 1
                }
            ],
        },
    ]
};
